// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"44b7346b","159":"003924a3","238":"ee1f1b65","239":"2ed84a93","255":"8fef3137","388":"f4ffb192","396":"e9ea77fb","455":"a4b2d7e8","857":"b85345d3","977":"49f729cd"}[chunkId] + ".chunk.js";
};